import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { BlockProps } from '../props'
import SectionWrapper from '../../../components/SectionWrapper'
import BlockCentralOffersCards, {
  BlockCentralOffersCardsProps,
} from '../../../components/blocks/BlockCentralOffersCards'
import { ActionButtonVariant } from '../../../components/ActionButton/styled'
import { ImageTransformer } from '../../Transformers/ImageTransformer'
import { ActionButtonTransformer } from '../../Transformers/LinkTransformer'
import Router from '../../../routes/Router'
import routes from '../../../routes/definitions'

import { OffersBlockProps } from './props'

const OffersBlock: FC<BlockProps<OffersBlockProps>> = ({ data }) => {
  const { t } = useTranslation()
  const props: BlockCentralOffersCardsProps = useMemo(
    () => ({
      title: data?.title,
      items: (data?.offres ?? []).map((offer) => ({
        category: offer?.categories?.[0]?.name,
        title: offer?.name,
        description: offer?.shortDescription,
        image: ImageTransformer(offer?.image),
        offerButton: {
          text: t('see_offer_button_text'),
          href: Router.getRouteUrl(routes.offer, { slug: offer?.slug }),
          variant: ActionButtonVariant.secondary,
        },
      })),
      button: {
        ...ActionButtonTransformer(data.link),
        variant: ActionButtonVariant.quaternary,
      },
    }),
    [t, data]
  )
  return (
    <SectionWrapper spacing="medium">
      <BlockCentralOffersCards {...props} />
    </SectionWrapper>
  )
}
export default OffersBlock
